import { Tick } from '@assets/index'
import React from 'react'
import './LanguageButton.scss'
import Text from '@components/Text/Text'
import { TextTag } from '@enums/textTag'
import classNames from 'classnames'

interface LanguageButtonProps {
  language: string
  buttonText: string
  setIsLoading: (isLoading: boolean) => void
  isLoading: boolean
  buttonRef?: React.RefObject<HTMLDivElement> | null
  setChooseLang: (language: string) => void
  chooseLang?: string | null
  onFocus?: () => void
  handleKeyDown?: (e: React.KeyboardEvent | React.MouseEvent) => void
  lastFocusedLanguage?: string
  columnIndex?: number
  rowIndex?: number
}

const LanguageButton = ({
  language,
  buttonText,
  buttonRef,
  chooseLang,
  onFocus,
  handleKeyDown,
  columnIndex,
  rowIndex,
}: LanguageButtonProps) => {
  if (!chooseLang) return <></>

  return (
    <div
      id={language}
      className={classNames('lang-button', 'focusable')}
      tabIndex={-1}
      onKeyDown={handleKeyDown}
      onClick={handleKeyDown}
      ref={buttonRef}
      onFocus={onFocus}
      data-language={language}
      data-column-index={columnIndex}
      data-row-index={rowIndex}
    >
      <Text tag={TextTag.P} className={`innerText ${chooseLang === language && 'active'}`}>
        {chooseLang === language && <Tick />}
        <Text tag={TextTag.SPAN} className="language">
          {buttonText}
        </Text>
      </Text>
    </div>
  )
}

export default LanguageButton
